module.exports = __webpack_public_path__ + "static/img/verkauf-deinen-gebrauchten.245bea0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/verkauf-deinen-gebrauchten.svg
// module id = GPbv
// module chunks = 1